<div class="col-md-12 login">
  <div class="card card-container">
    
    <form
      *ngIf="!isLoggedIn"
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
    <div class="form-title">
      <h1>Connexion</h1>
    </div>
      <div class="form-group">
        <label for="login">Courriel</label>
        <input
          type="email"
          class="form-control"
          name="login"
          [(ngModel)]="form.login"
          required
          email="true"
          #login="ngModel"
        />
        
      </div>

      <div class="form-group">
        <label for="password">Mot de passe</label>
        <input
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="form.password"
          required
          minlength="6"
          #password="ngModel"
        />
      <br/>
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="password.errors && f.submitted"
        >
          <div *ngIf="password.errors['required']">Mot de passe requis</div>
          <div *ngIf="password.errors['minlength']">
            Le mot de passe doit être au moins 6 caractères
          </div>
        </div>

        <div *ngIf="login.touched && login.errors?.['email']" class="alert alert-danger" role="alert">
          <span>Entrez un courriel valide.</span>
        </div>
        
        <div class="alert alert-danger" role="alert" *ngIf="login.errors && f.submitted">
          <span>Le courriel est requis!</span>
        </div>
      </div>

      <div class="form-group mt-3">
        <button class="btn btn-primary btn-block">
        Connexion
        </button>
      </div>

      <div class="form-group">
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="f.submitted && isLoginFailed"
        >
         Connexion erronée: {{ errorMessage }}
        </div>
      </div>
    </form>

      <div class="alert alert-success login-msg" *ngIf="isLoggedIn">
        Connecté
      </div>
    
      <div class="mt-3 text-center" *ngIf="!isLoggedIn">
        <a href="mot-de-passe-oublie" routerLink="/mot-de-passe-oublie">J'ai oublié mon mot de passe</a>
        <br>
      </div>
  </div>

</div>
